// Formats YYYY-MM-DD to DD.MM.YYYY
export function convertDate(dateString) {
  let newDateArr = dateString.split("-")
  return `${newDateArr[2]}.${newDateArr[1]}.${newDateArr[0]}`
}
